import { put, takeLatest, fork, call } from "redux-saga/effects";
import { ActionType } from "models/messagemanagement/resendMessage";
import { httpStatus } from "configs/httpStatus";
import { resendMessage } from "services/messagemanagement";
import { handleSuccesAction, handleErrorAction } from "./resendMessageActions";
import { history } from "../../configureStore";
import {
  IResendMessageResponse,
  IResendMessagePayload,
} from "models/messagemanagement/resendMessage";

function* resendMessageSaga({ payload }: { payload: IResendMessagePayload }) {
  try {
    const response: IResendMessageResponse = yield call(resendMessage, payload);
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (
      response.status === httpStatus.StatusUnauthorized ||
      response.status === httpStatus.StatusForbidden
    ) {
      yield put(handleErrorAction(response.message || ""));
      history.push("/login");
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onResendMessageWatcher() {
  yield takeLatest(ActionType.RESEND_MESSAGE as any, resendMessageSaga);
}

export default [fork(onResendMessageWatcher)];
